import TfacReportPage from "@/components/pages/report/tfac/TfacReportPage.vue";
import PurchaseSummaryByCourseReportPage from "@/components/pages/report/tfac/PurchaseSummaryByCourseReportPage.vue";
import EnrollSummaryByCourseReportPage from "@/components/pages/report/tfac/EnrollSummaryByCourseReportPage.vue";
import TfacIndividualStudentFile from "@/components/pages/report/tfac/TfacIndividualStudentFile.vue";
import TfacIndividualStudentFileInfo from "@/components/pages/report/tfac/TfacIndividualStudentFileInfo.vue";
import TfacCompletedEnrollByDateReport from "@/components/pages/report/tfac/TfacCompletedEnrollByDateReport.vue"
import ExamDetailedResultReport from "../components/pages/report/ExamDetailedResultReport.vue";
import ThaireCompletedCoursesReport from "../components/pages/report/thaire/ThaireCompletedCoursesReport.vue";
import TrialEnrollmentReport from "../components/pages/report/TrialEnrollmentReport.vue";
import StudentCourseSummaryReport from "../components/pages/report/StudentCourseSummaryReport.vue";
import StudentCountBySchoolReport from "../components/pages/report/StudentCountBySchoolReport.vue";
import WannasornLearningHistorySummaryReport from "../components/pages/report/WannasornLearningHistorySummaryReport.vue";
import StudentInfoReport from "../components/pages/report/StudentInfoReport.vue";

export default [
    {
        path: "report/tfac/report",
        name: "report.tfac.report",
        component: TfacReportPage,
        meta: {
            access: { menu: "report", subMenu: "tfac-revenue-summary-by-course-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"],
        },
    },
    {
        path: "report/tfac/purchase-summary-by-course-report",
        name: "report.tfac.purchasesummarybycoursereport",
        component: PurchaseSummaryByCourseReportPage,
        meta: {
            access: { menu: "report", subMenu: "tfac-purchase-summary-by-course-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"],
        },
    },
    {
        path: "report/tfac/enroll-summary-by-course-report",
        name: "report.tfac.enrollsummarybycoursereport",
        component: EnrollSummaryByCourseReportPage,
        meta: {
            access: { menu: "report", subMenu: "tfac-enroll-summary-by-course-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"],
        },
    },
    {
        path: "report/tfac/individual-student-report",
        name: "report.tfac.individualstudentfile",
        component: TfacIndividualStudentFile,
        meta: {
            access: { menu: "report", subMenu: "tfac-individual-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"],
        },
    },
    {
        path: "report/tfac/individual-student-report-info",
        name: "report.tfac.individualstudentfileinfo",
        component: TfacIndividualStudentFileInfo,
        meta: {
            access: { menu: "report", subMenu: "tfac-individual-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"],
        },
    },
    {
        path: "report/tfac/completed-enroll-by-date-report",
        name: "report.tfac.completedEnrollByDateReport",
        component: TfacCompletedEnrollByDateReport,
        meta: {
            access: { menu: "report", subMenu: "tfac-completed-enoll-by-date-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"]
        }
    },
    {
        path: "report/exam-detailed-result-report",
        name: "report.exam-detailed-result-report",
        meta: { access: { menu: "report", subMenu: "exam-detailed-result-report" } },
        component: ExamDetailedResultReport,
    },
    {
        path: "report/thaire/completed-courses-report",
        name: "report.thaire.completedCoursesReport",
        component: ThaireCompletedCoursesReport,
        meta: {
            access: { menu: "report", subMenu: "thaire-completed-courses-report" },
            authRequired: true,
            permsRequired: ["read-revenue-analytic"]
        }
    },
    {
        path: "report/trial-course-enrollment-report",
        name: "report.trial-course-enrollment-report",
        component: TrialEnrollmentReport,
        meta: {
            access: { menu: "report", subMenu: "trial-course-history-report" },
            authRequired: true,
        }
    },
    {
        path: "report/student-course-summary-report",
        name: "report.student-course-summary-report",
        component: StudentCourseSummaryReport,
        meta: {
            access: { menu: "report", subMenu: "student-course-summary-report" },
            authRequired: true,
        }
    },
    {
        path: "report/student-count-by-school-report",
        name: "report.student-count-by-school-report",
        component: StudentCountBySchoolReport,
        meta: {
            access: { menu: "report", subMenu: "student-count-by-school-report" },
            authRequired: true,
        }
    },
    {
        path: "report/learning-history-summary-report",
        name: "report.learning-history-summary-report",
        component: WannasornLearningHistorySummaryReport,
        meta: {
            access: { menu: "report", subMenu: "learning-history-summary-report" },
            authRequired: true,
        }
    },
    {
        path: "report/student-info-report",
        name: "report.student-info-report",
        component: StudentInfoReport,
        meta: {
            access: { menu: "report", subMenu: "student-info-report" },
            authRequired: true,
        },
    }
];